import { useEffect, useState, useCallback, useMemo, createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { adminToken } from "./adminSession";

export const ADMIN_API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isCallback = location.pathname === "/admin/auth/callback";

  useEffect(() => {
    // The callback establishes its session before any /me check runs.
    if (isCallback) {
      setUser(null);
      setLoading(false);
      return;
    }
    let active = true;
    const token = adminToken.get();
    setLoading(true);
    axios.get(`${ADMIN_API}/auth/me`, {
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      timeout: 20000,
    })
      .then((r) => { if (active) setUser(r.data.user); })
      .catch(() => { if (active) setUser(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [isCallback]);

  const logout = useCallback(async () => {
    const token = adminToken.get();
    try {
      await axios.post(`${ADMIN_API}/auth/logout`, null, {
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: 20000,
      });
    } catch (err) {
      console.error("Admin logout request failed:", err.message);
    }
    adminToken.clear();
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, setUser, loading, logout }), [user, loading, logout]);
  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export const useAdminAuth = () => useContext(AdminAuthContext);